// @flow
import React from "react";
import { NumberField } from "@quantum/ui";
import { Translate } from "@quantum/i18n";
import { connect } from "react-redux";
import {
  type ActionCreator,
  selecionarTamanhoJanela,
  getTamanhoJanelaSelecionada,
  getTipoJanelaSelecionada,
} from "../../../../../../state";
import {
  type Id,
  ID_TIPO_JANELA_MESES,
  TAMANHO_DEFAULT_JANELA_TIPO_DIAS_UTEIS,
  TAMANHO_DEFAULT_JANELA_TIPO_MESES,
} from "../../../../../../model";

type Prop = {
  tamanho: number,
  tipoJanela: Id,
  selecionarTamanhoJanela: ActionCreator,
};

function SelecaoTamanhoJanela({
  tamanho,
  tipoJanela,
  selecionarTamanhoJanela,
}: Prop) {
  function onTamanhoJanelaChange(tamanho) {
    selecionarTamanhoJanela(tamanho);
  }

  function onBlur() {
    if (!tamanho) {
      tipoJanela === ID_TIPO_JANELA_MESES
        ? selecionarTamanhoJanela(TAMANHO_DEFAULT_JANELA_TIPO_MESES)
        : selecionarTamanhoJanela(TAMANHO_DEFAULT_JANELA_TIPO_DIAS_UTEIS);
    }
  }

  return (
    <>
      <label className="ConfiguracaoMedida__label">
        <Translate>
          {tipoJanela === ID_TIPO_JANELA_MESES
            ? "periodos.janela.meses"
            : "periodos.janela.diasUteis"}
        </Translate>
      </label>
      <NumberField
        className="ConfiguracaoMedida__input"
        allowNegative={false}
        max={365}
        min={1}
        onChangeValue={onTamanhoJanelaChange}
        value={tamanho}
        onBlur={onBlur}
      />
    </>
  );
}

export default connect(
  state => ({
    tamanho: getTamanhoJanelaSelecionada(state),
    tipoJanela: getTipoJanelaSelecionada(state),
  }),
  { selecionarTamanhoJanela }
)(SelecaoTamanhoJanela);
